import clsx from 'clsx';
import { CSSProperties, ReactNode, useMemo } from 'react';

import style from './GridSelect.module.css';

export interface GridSelectProps {
  selectedOptionIndex?: number;
  errorText: string;
  showErrorIfNeeded: boolean;
  itemsPerRowMobile?: number;
  children: ReactNode | ReactNode[];
}

export const GridSelect = ({ children, selectedOptionIndex, errorText, showErrorIfNeeded, itemsPerRowMobile }: GridSelectProps) => {
  const showError = useMemo(() => showErrorIfNeeded && selectedOptionIndex === undefined, [selectedOptionIndex, showErrorIfNeeded]);

  const customStyle = useMemo(() => {
    if (!itemsPerRowMobile) {
      return undefined;
    }
    return { '--grid-layout-items-per-row-mobile': itemsPerRowMobile } as CSSProperties;
  }, [itemsPerRowMobile]);

  return (
    <div className={clsx(style.root)} style={customStyle}>
      {showError && <div className={clsx(style.error)}>{errorText}</div>}
      <div className={clsx(style.options)}>{children}</div>
    </div>
  );
};
